import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilesService } from '../../../core/services/files.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppUtils } from '../../../core/config/app.utils';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { CurrencyService } from '../../../core/services/currency.service';
import { RentReservationService } from '../../../core/services/rent-reservation.service';
import { PaymentsService } from '../../../core/services/payments.service';

const PAYMENT_POPUP_ATTACHMENT = 'AGENT_ADD_EDIT_POPUP_ATTACHMENT';

@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.scss'],
})
export class PaymentPopupComponent implements OnInit {
  @Output() addPaymentOnChange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible = false;
  @Input() reservationId: any;
  @Input() chargesOptions: any[] = [];
  paymentForm: FormGroup | any;
  formErrors: any;
  attachments: any[] = [];
  payments: any[] = [];
  attachmentUploading = false;
  currencyOptions: any[] = [];
  amountInLKR = '';
  selectedPayment: any = {};
  selectedIndex = 0;
  type = '';
  iIndex = 0;

  popupLoading = false;

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private message: NzMessageService,
    private currencyService: CurrencyService,
    private rentReservationService: RentReservationService,
    private paymentService: PaymentsService,
  ) {
    this.formErrors = {
      item: {},
      type: {},
      amount: {},
    };
  }

  ngOnInit(): void {
    this.uploadLoader();
    this.getCurrencyOptions();
    this.initPaymentForm();
    this.handleDataPopulation();
  }

  handleDataPopulation(): void {
    this.popupLoading = true;
    this.rentReservationService.selectedReservationDetails.subscribe(
      (res: any) => {
        this.reservationId = res.id;
        this.payments = res.payments;
        const modifiedItems: any[] = [];

        if (res.type === 'edit') {
          this.type = 'edit';
          this.selectedPayment = res.selectedPayment;
          this.selectedIndex = res.index;

          this.paymentForm.patchValue(res.selectedPayment);
          this.paymentForm.get('items').clear();
          if (this.selectedPayment?.items?.length > 0) {
            this.selectedPayment?.items?.forEach((item: any) => {
              (this.paymentForm.get('items') as FormArray).push(
                this.createItem(),
              );
              if (
                !this.chargesOptions.find(
                  (op: any) => op.chargeType === item.chargeType,
                )
              ) {
                this.addItem({ value: item.chargeType });
              }

              const option = this.chargesOptions.find(
                (op: any) => op.chargeType === item.chargeType,
              );

              if (option) {
                modifiedItems.push({
                  chargeType: option,
                  amount: item.amount,
                  currency: item.currency,
                  currencyDetails: item.currencyDetails,
                });
              } else {
                modifiedItems.push({
                  chargeType: { chargeType: item.chargeType },
                  amount: item.amount,
                  currency: item.currency,
                  currencyDetails: item.currencyDetails,
                });
              }
            });

            this.paymentForm.patchValue({
              items: modifiedItems,
            });
          }
          this.attachments = this.selectedPayment?.attachments;
          this.popupLoading = false;
        } else {
          this.popupLoading = false;
          this.type = 'add';
        }
      },
    );
  }

  uploadLoader() {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case PAYMENT_POPUP_ATTACHMENT:
          this.attachmentUploading = res.loading;
          break;
      }
    });
  }

  getCurrencyOptions(): void {
    this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
      this.currencyOptions = res;

      // const lkr = res?.find((cu: any) => cu.currencyCode === 'LKR');
      // this.rentBookingForm.patchValue({
      //   tourDetails: {
      //     costPerExtraMileageCurrency: lkr?._id,
      //     costPerExtraMileageCurrencyDetails: lkr,
      //   },
      //   allocationDetails: {
      //     outsourcedRateCurrency: lkr?._id,
      //     outsourcedRateCurrencyDetails: lkr,
      //   },
      //   bookingCostInformation: {
      //     depositCurrency: lkr?._id,
      //     depositCurrencyDetails: lkr,
      //     totalRentalAmountCurrency: lkr?._id,
      //     totalRentalAmountCurrencyDetails: lkr,
      //     prepaidAmountCurrency: lkr?._id,
      //     prepaidAmountCurrencyDetails: lkr,
      //     rentalAmountDueCurrency: lkr?._id,
      //     rentalAmountDueCurrencyDetails: lkr,
      //
      //   }
      //
      // })
    });
  }

  initPaymentForm(): void {
    this.paymentForm = this.fb.group({
      items: this.fb.array([this.createItem()]),
      type: [null, [Validators.required]],
      description: [null, []],
      totalAmount: [null, [Validators.required]],
    });

    this.paymentForm.get('items').valueChanges.subscribe((values: any[]) => {
      if (
        this.type === 'add' ||
        (this.type === 'edit' && this.paymentForm.dirty)
      ) {
        this.setItemValues(values);
      }
    });

    this.paymentForm.valueChanges.subscribe((values: any) => {
      this.formErrors = AppUtils.getFormErrors(
        this.paymentForm,
        this.formErrors,
      );
    });
  }

  // items form array stuff
  createItem(): FormGroup {
    return this.fb.group({
      chargeType: ['', [Validators.required]],
      amount: [0, []],
      currency: [null, []],
      currencyDetails: [null, []],
    });
  }

  public get items(): FormArray {
    return this.paymentForm.get('items') as FormArray;
  }

  deleteItem(index: any): void {
    this.items.removeAt(index);

    const items = this.paymentForm.get('items').value;
    this.setItemValues(items);
  }

  setItemValues(values: any[]) {
    let totalAmount = 0;
    values.forEach((item: any, index: number) => {
      if (item?.chargeType?.amount) {
        this.paymentForm
          .get('items')
          .at(index)
          .setValue(
            {
              chargeType: item?.chargeType,
              amount: item?.chargeType?.amount,
              currency: item?.chargeType?.currency,
              currencyDetails: item?.chargeType?.currencyDetails,
            },
            { onlySelf: true, emitEvent: true },
          );

        totalAmount =
          totalAmount +
          item?.chargeType?.currencyDetails?.lkrRate * item?.chargeType?.amount;
      } else {
        if (item.currency && item.amount) {
          const cu = this.currencyOptions?.find(
            (cu: any) => cu._id === item.currency,
          );
          this.paymentForm
            .get('items')
            .at(index)
            .setValue(
              {
                chargeType: item?.chargeType,
                amount: item?.amount,
                currency: item?.currency,
                currencyDetails: cu,
              },
              { onlySelf: true, emitEvent: true },
            );

          totalAmount = totalAmount + cu?.lkrRate * item?.amount;
        }
      }
    });
    this.paymentForm
      .get('totalAmount')
      .setValue(totalAmount, { emitEvent: false, onlySelf: true });
  }

  addPaymentItem(): void {
    this.items.push(this.createItem());
  }

  addItem(input: any): void {
    const value = input.value;
    if (this.chargesOptions.indexOf(value) === -1) {
      this.chargesOptions = [
        ...this.chargesOptions,
        {
          chargeType: input.value || `New item ${this.iIndex++}`,
        },
      ];
    }
  }

  upload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, PAYMENT_POPUP_ATTACHMENT)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.attachments.push({ name: data.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: PAYMENT_POPUP_ATTACHMENT,
          loading: false,
        });
      });

  cancel(): void {}

  confirm(): void {
    this.isVisible = false;
    this.addPaymentOnChange.emit({ name: 'isVisible', value: false });
  }

  async onSubmit(): Promise<void> {
    const formData = this.paymentForm.getRawValue();
    const items: any[] = [];
    formData?.items?.forEach((item: any) => {
      item.chargeType = item.chargeType?.chargeType;
      items.push(item);
    });
    formData.items = items;
    try {
      if (this.type === 'add') {
        // this.payments.push({
        //   ...formData,
        //   attachments: this.attachments,
        //   createdAt: new Date(),
        // });
        await this.paymentService.createPayment({
          ...formData,
          attachments: this.attachments,
          createdAt: new Date(),
          bookingType: 'RENT',
          bookingId: this.reservationId,
        });
      } else {
        // this.payments[this.selectedIndex] = {
        //   ...formData,
        //   attachments: this.attachments,
        //   createdAt: this.selectedPayment.createdAt,
        // };
        await this.paymentService.updatePayment({
          ...formData,
          attachments: this.attachments,
          createdAt: this.selectedPayment.createdAt,
          _id: this.selectedPayment._id,
        });
      }

      // this.rentReservationService
      //   .updateRentReservation({
      //     _id: this.reservationId,
      //     payments: this.payments,
      //   })
      //   .subscribe(
      //     () => {
      //       this.paymentForm.reset();
      //       this.attachments = [];
      //       this.reservationId = null;
      //       this.payments = [];
      //       this.isVisible = false;
      //       this.rentReservationService.selectedReservationDetails.next({});
      //       this.addPaymentOnChange.emit({
      //         name: 'created',
      //         value: false,
      //       });
      //     },
      //     (e: any) => {},
      //   );
      this.paymentForm.reset();
      this.attachments = [];
      this.reservationId = null;
      this.payments = [];
      this.isVisible = false;
      this.rentReservationService.selectedReservationDetails.next({});
      this.addPaymentOnChange.emit({
        name: 'created',
        value: false,
      });
    } catch (e) {
      this.message.create('error', `Payment has not been updated!`);
    }
  }

  confirmRemoveAttachment(index: any): void {
    this.attachments.splice(index, 1);
    this.message.create('success', `Attachment has been deleted!`);
  }

  onCancelConfirm(): void {
    this.paymentForm.reset();
    this.attachments = [];
    this.reservationId = null;
    this.payments = [];
    this.isVisible = false;
    this.rentReservationService.selectedReservationDetails.next({});
    this.addPaymentOnChange.emit({
      name: 'isVisible',
      value: false,
    });
  }

  handleCancel(): void {
    this.paymentForm.reset();
    this.attachments = [];
    this.isVisible = false;
    this.reservationId = null;
    this.payments = [];
    this.rentReservationService.selectedReservationDetails.next({});
    this.addPaymentOnChange.emit({
      name: 'isVisible',
      value: false,
    });
  }

  handleOk(): void {}
}
